import { useEffect, useState } from "react";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import Home_Private_Confidential from "../home_page_components/home_private_confidential/Home_Private_Confidential";
import { Get_Astrology_data } from "../../../api/global/Global";
import parse from 'html-react-parser';
import Loader from "../../../loader/Loader";
import Kundli_Main_Banner from "../kundli/kundli_main_bannner/Kundli_Main_Banner";
import { Helmet } from "react-helmet";
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from "../../../config/Config";
import { useNavigate, useParams } from "react-router-dom";
import Kundli_Common_Section from "../kundli/kundli_common_section/Kundli_Common_Section";
import { toast } from "react-toastify";
import Free_Get_Kundli_Form from "../kundli/free_kundli/Free_Get_Kundli_Form";
import Common_Images_Transport from "../../common/common_imges_transport/Common_Images_Transport";
import Horoscope from "../kundli/horoscope/Horoscope";
import { isAlphabetical } from "../../validation/Validation";
import { Get_Match_Making_PDF, Get_Love_Compatibility_Report, Get_Advanced_Panchang } from "../../../api/global/Global";

export const ImportantPageLayout = () => {
    const navigate = useNavigate()
    const { slug } = useParams()
    const [astrology_data, set_AstrologyData] = useState({});
    const [is_loading, set_Is_Loading] = useState(false)
    const [love_calculator_form, set_Love_Calculator_Form] = useState({
        name: "",
        your_gender: "",
        your_dob: "",
        your_birth_place: "",
        partner_name: "",
        partner_gender: "",
        partner_dob: "",
        partner_birth_place: "",
    })
    const [errorMessage, setErrorMessage] = useState('');
    const [matchPdfUrl, setMatchPdfUrl] = useState(null);
    const [matchReportData, setMatchReportData] = useState(null);
    const [is_match_submitting, set_Is_Match_Submitting] = useState(false);
    const [loveReport, setLoveReport] = useState([]);
    const [is_love_submitting, set_Is_Love_Submitting] = useState(false);


    // <------------panchang-form-handling---------->

    const [panchangform, setPanchangeForm] = useState({
        location: "",
        date: ""
    })
    const [panchangResult, setPanchangResult] = useState(null);
    const [is_panchang_submitting, setIsPanchangSubmitting] = useState(false);

    const handlePanchangeChange = (e) => {
        const { name, value } = e.target;
        setPanchangeForm({
            ...panchangform,
            [name]: value
        })
    }

    const HandleSubmit = async (e) => {
        e.preventDefault();
        if (!panchangform.location) {
            toast.error("Please enter your location");
            return;
        }
        if (!panchangform.date) {
            toast.error("Please select the panchang date");
            return;
        }
        try {
            setIsPanchangSubmitting(true);
            const dateObj = new Date(panchangform.date);
            const payload = {
                day: dateObj.getDate(),
                month: dateObj.getMonth() + 1,
                year: dateObj.getFullYear(),
                hour: dateObj.getHours() || 19,
                min: dateObj.getMinutes() || 55,
                lat: 19.2056,
                lon: 25.2056,
                tzone: 5.5
            };
            const response = await Get_Advanced_Panchang(payload);
            const resultData = response?.data || response;
            if (resultData && (resultData.tithi || resultData.day || resultData.sunrise)) {
                setPanchangResult(resultData);
                toast.success("Panchang details fetched successfully!");
            } else {
                toast.error("Failed to fetch panchang details. Please try again.");
            }
        } catch (error) {
            console.error("Panchang API error", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            setIsPanchangSubmitting(false);
        }
    }
    // <---------panchangformhandling------------->

    // <-------------kundali matching form------------->
    const [boys_Detail, set_Boys_detail] = useState({
        name: '',
        date_time: "",
        birth_place: ''
    })

    const [girl_Detail, set_Girl_Detail] = useState({
        name: '',
        date_time: "",
        birth_place: ''
    })

    const handle_BoyDetail = (e) => {
        setErrorMessage("");
        const { name, value } = e.target
        if (name === "name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        set_Boys_detail((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    const handle_GirlDetail = (e) => {
        setErrorMessage("");
        const { name, value } = e.target
        if (name === "name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        set_Girl_Detail((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    // submit form function
    const handle_Submit = async (e) => {
        e.preventDefault();
        if (!boys_Detail.name) {
            toast("Please enter boy's name");
            return;
        }
        if (!boys_Detail.date_time) {
            toast("Please select boy's date & time");
            return;
        }
        if (!boys_Detail.birth_place) {
            toast("Please enter boy's birth place");
            return;
        }
        if (!girl_Detail.name) {
            toast("Please enter girl's name");
            return;
        }
        if (!girl_Detail.date_time) {
            toast("Please select girl's date & time");
            return;
        }
        if (!girl_Detail.birth_place) {
            toast("Please enter girl's birth place");
            return;
        }
        try {
            set_Is_Match_Submitting(true);
            setMatchReportData(null);
            setMatchPdfUrl(null);
            const parseBoy = new Date(boys_Detail.date_time);
            const parseGirl = new Date(girl_Detail.date_time);
            const payload = {
                m_day: parseBoy.getDate(),
                m_month: parseBoy.getMonth() + 1,
                m_year: parseBoy.getFullYear(),
                m_hour: parseBoy.getHours(),
                m_min: parseBoy.getMinutes(),
                m_lat: 19.2056,
                m_lon: 25.2056,
                m_tzone: 5.5,
                f_day: parseGirl.getDate(),
                f_month: parseGirl.getMonth() + 1,
                f_year: parseGirl.getFullYear(),
                f_hour: parseGirl.getHours(),
                f_min: parseGirl.getMinutes(),
                f_lat: 19.2056,
                f_lon: 25.2056,
                f_tzone: 5.5
            };
            const response = await Get_Match_Making_PDF(payload);
            const reportData = response?.data?.data || response?.data || response;
            if (reportData && (reportData.ashtakoota || reportData.conclusion || reportData.manglik)) {
                setMatchReportData(reportData);
                toast.success("Kundli matching detailed report generated!");
            } else if (response?.data?.data?.pdf_url || response?.data?.pdf_url) {
                setMatchPdfUrl(response?.data?.data?.pdf_url || response?.data?.pdf_url);
                toast.success("Kundli matching report generated!");
            } else {
                toast.error("Failed to generate matching report. Please try again.");
            }
        } catch (error) {
            console.error("Match Making Detailed Report error", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            set_Is_Match_Submitting(false);
        }
    };
    // <-------------kundali matching form------------->


    // <--------------- Love Calculator onchnage section's ----------->
    const HandleLoveCalclatorChange = (e) => {
        setErrorMessage("");
        const { name, value } = e.target;
        if (name === "name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        if (name === "partner_name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        if (name === "your_birth_place" && value && !isAlphabetical(value)) {
            setErrorMessage("* Birth place should only contain alphabetic characters");
            return;
        }
        if (name === "partner_birth_place" && value && !isAlphabetical(value)) {
            setErrorMessage("* Birth place should only contain alphabetic characters");
            return;
        }
        set_Love_Calculator_Form({
            ...love_calculator_form,
            [name]: value
        })
    }

    // <--------------- Submit the Love Calculator Form -------------->
    const HandleSubmitLoveCalculator = async (e) => {
        e.preventDefault();
        if (!love_calculator_form.name) {
            toast("please enter your name")
            return;
        }
        else if (!love_calculator_form.your_gender) {
            toast("please select your gender")
            return;
        }
        else if (!love_calculator_form.partner_name) {
            toast("please enter your partner name ")
            return;
        }
        else if (!love_calculator_form.partner_gender) {
            toast("please select your partner's gender ")
            return;
        }
        else if (!love_calculator_form.your_dob) {
            toast("please enter your date & time of birth")
            return;
        }
        else if (!love_calculator_form.your_birth_place) {
            toast("please enter your birth place")
            return;
        }
        else if (!love_calculator_form.partner_dob) {
            toast("please enter partner's date & time of birth")
            return;
        }
        else if (!love_calculator_form.partner_birth_place) {
            toast("please enter partner's birth place")
            return;
        }
        try {
            set_Is_Love_Submitting(true);
            const pDt = new Date(love_calculator_form.your_dob);
            const sDt = new Date(love_calculator_form.partner_dob);
            const payload = {
                p_day: pDt.getDate(),
                p_month: pDt.getMonth() + 1,
                p_year: pDt.getFullYear(),
                p_hour: pDt.getHours(),
                p_min: pDt.getMinutes(),
                p_lat: 24.772608,
                p_lon: 73.7574912,
                p_tzone: 5.5,
                s_day: sDt.getDate(),
                s_month: sDt.getMonth() + 1,
                s_year: sDt.getFullYear(),
                s_hour: sDt.getHours(),
                s_min: sDt.getMinutes(),
                s_lat: 24.772608,
                s_lon: 73.7574912,
                s_tzone: 5.5,
            };
            const response = await Get_Love_Compatibility_Report(payload);
            if (response?.data?.love_report) {
                setLoveReport(response.data.love_report);
                toast.success("Love compatibility report generated!");
            } else {
                toast.error("Failed to generate love report. Please try again.");
            }
        } catch (error) {
            console.error("Love compatibility error", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            set_Is_Love_Submitting(false);
        }
    }


    useEffect(() => {
        const Handle_Get_Astrology_data = async () => {
            set_Is_Loading(true)
            try {
                const response = await Get_Astrology_data(slug);
                if (response?.data?.status == 200) {
                    set_AstrologyData(response?.data?.data?.astrology)
                }
                if (response?.response?.data?.status == 500) {
                    toast.error(response?.response?.data?.message)
                    navigate("/")
                }
            } catch (error) {
                console.error("error", error)
            } finally {
                set_Is_Loading(false)
            }
        }
        if (slug) {  // make sure slug exists before calling
            Handle_Get_Astrology_data();
        }
    }, [slug])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <Helmet>
                            <title>{astrology_data?.meta_title}</title>
                            <meta name="description" content={astrology_data?.meta_description} />

                            <link rel="canonical" href={`${WEB_DOMAIN_KEY}page/${astrology_data?.slug}`} />
                            <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}page/${astrology_data?.slug}`} />

                        </Helmet>

                        <Header />
                        {/* <------------ Kundli_Main_Banner ---------> */}
                        < Kundli_Main_Banner banner={{ banner: astrology_data?.banner, alt: astrology_data?.alt }} />
                        {
                            astrology_data?.page_name === "how-to-read-kundli" && (
                                <section className="gi-faq py-12 bg-[#F0F4F8]">
                                    <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-md border border-gray-100">
                                            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{astrology_data?.title}</h1>
                                            <div className="h-[2px] w-16 bg-[#9F2225] mb-6"></div>
                                            <div className="custome_viewbox prose max-w-none text-gray-700 leading-relaxed text-sm md:text-base">
                                                {astrology_data?.description ? parse(String(astrology_data.description)) : ""}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )
                        }
                        {
                            astrology_data?.page_name === "panchang" && (
                                <>
                                    <section className="gi-category py-10 md:py-16 bg-[#F0F4F8]">
                                        <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100">
                                                <div className="flex flex-col lg:flex-row gap-8 items-center">
                                                    {/* Form */}
                                                    <div className="w-full lg:w-2/3 space-y-6">
                                                        <div className="border-b border-gray-100 pb-4">
                                                            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{astrology_data?.title}</h1>
                                                            <p className="text-gray-500 text-sm">Generate panchang using Ayanamsa, place, date</p>
                                                        </div>
                                                        <form onSubmit={HandleSubmit} className="space-y-4">
                                                            <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 items-end">
                                                                <div className="sm:col-span-5">
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Location</label>
                                                                    <input
                                                                        placeholder="Enter Location"
                                                                        value={panchangform.location}
                                                                        name="location"
                                                                        onChange={handlePanchangeChange}
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        type="text"
                                                                        required
                                                                    />
                                                                </div>
                                                                <div className="sm:col-span-4">
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Date</label>
                                                                    <input
                                                                        value={panchangform.date}
                                                                        name="date"
                                                                        onChange={handlePanchangeChange}
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        type="date"
                                                                        required
                                                                    />
                                                                </div>
                                                                <div className="sm:col-span-3">
                                                                    <button
                                                                        type="submit"
                                                                        disabled={is_panchang_submitting}
                                                                        className="w-full h-11 bg-[#9F2225] hover:bg-[#831c1e] text-white text-sm font-bold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 uppercase tracking-wide disabled:opacity-60"
                                                                    >
                                                                        {is_panchang_submitting ? 'Fetching...' : 'Get Result'}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>

                                                    {/* Image */}
                                                    <div className="w-full lg:w-1/3 flex justify-center">
                                                        <div className="rounded-2xl overflow-hidden border border-gray-100 shadow-sm w-full max-w-[100%] sm:max-w-[100%] md:max-w-[100%] lg:max-w-full">
                                                            <img
                                                                src={`${IMG_BASE_URL}${astrology_data?.image}`}
                                                                alt={astrology_data?.alt}
                                                                className="w-full h-auto object-cover"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Panchang Results Card */}
                                            {panchangResult && (
                                                <div className="mt-8 bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100 space-y-6">
                                                    <div className="border-b border-gray-100 pb-4 flex flex-wrap justify-between items-center gap-2">
                                                        <div>
                                                            <h2 className="text-xl font-bold text-gray-900">Advanced Panchang Details</h2>
                                                            <p className="text-xs text-gray-500 capitalize">{panchangResult?.day} • {panchangResult?.paksha} • {panchangResult?.ritu} Ritu</p>
                                                        </div>
                                                        <div className="flex flex-wrap gap-4 text-xs font-semibold text-gray-700 bg-gray-50 p-2.5 rounded-lg border border-gray-200">
                                                            <div><span className="text-gray-400">Sunrise:</span> {panchangResult?.sunrise}</div>
                                                            <div><span className="text-gray-400">Sunset:</span> {panchangResult?.sunset}</div>
                                                            <div><span className="text-gray-400">Moonrise:</span> {panchangResult?.moonrise}</div>
                                                            <div><span className="text-gray-400">Moonset:</span> {panchangResult?.moonset}</div>
                                                        </div>
                                                    </div>

                                                    {/* Key Panchang Parameters Grid */}
                                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                                        {/* Tithi */}
                                                        <div className="bg-[#9F2225]/5 border border-[#9F2225]/10 rounded-xl p-4">
                                                            <div className="text-xs font-bold text-[#9F2225] uppercase tracking-wider mb-1">Tithi</div>
                                                            <div className="text-base font-bold text-gray-900">{panchangResult?.tithi?.details?.tithi_name || '-'}</div>
                                                            <p className="text-xs text-gray-600 mt-1 line-clamp-2">{panchangResult?.tithi?.details?.summary}</p>
                                                            {panchangResult?.tithi?.details?.deity && (
                                                                <p className="text-xs text-gray-500 mt-2 font-medium">Deity: {panchangResult.tithi.details.deity}</p>
                                                            )}
                                                        </div>

                                                        {/* Nakshatra */}
                                                        <div className="bg-[#9F2225]/5 border border-[#9F2225]/10 rounded-xl p-4">
                                                            <div className="text-xs font-bold text-[#9F2225] uppercase tracking-wider mb-1">Nakshatra</div>
                                                            <div className="text-base font-bold text-gray-900">{panchangResult?.nakshatra?.details?.nak_name || '-'}</div>
                                                            <p className="text-xs text-gray-600 mt-1 line-clamp-2">{panchangResult?.nakshatra?.details?.summary}</p>
                                                            {panchangResult?.nakshatra?.details?.ruler && (
                                                                <p className="text-xs text-gray-500 mt-2 font-medium">Ruler: {panchangResult.nakshatra.details.ruler}</p>
                                                            )}
                                                        </div>

                                                        {/* Yog */}
                                                        <div className="bg-[#9F2225]/5 border border-[#9F2225]/10 rounded-xl p-4">
                                                            <div className="text-xs font-bold text-[#9F2225] uppercase tracking-wider mb-1">Yog</div>
                                                            <div className="text-base font-bold text-gray-900">{panchangResult?.yog?.details?.yog_name || '-'}</div>
                                                            <p className="text-xs text-gray-600 mt-1 line-clamp-2">{panchangResult?.yog?.details?.meaning || panchangResult?.yog?.details?.special}</p>
                                                        </div>

                                                        {/* Karan */}
                                                        <div className="bg-[#9F2225]/5 border border-[#9F2225]/10 rounded-xl p-4">
                                                            <div className="text-xs font-bold text-[#9F2225] uppercase tracking-wider mb-1">Karan</div>
                                                            <div className="text-base font-bold text-gray-900">{panchangResult?.karan?.details?.karan_name || '-'}</div>
                                                            <p className="text-xs text-gray-600 mt-1 line-clamp-2">{panchangResult?.karan?.details?.special}</p>
                                                        </div>
                                                    </div>

                                                    {/* Additional Summary Grid */}
                                                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 text-xs bg-gray-50 p-4 rounded-xl border border-gray-100">
                                                        <div><span className="text-gray-400 block">Sun Sign</span><span className="font-semibold text-gray-800">{panchangResult?.sun_sign || '-'}</span></div>
                                                        <div><span className="text-gray-400 block">Moon Sign</span><span className="font-semibold text-gray-800">{panchangResult?.moon_sign || '-'}</span></div>
                                                        <div><span className="text-gray-400 block">Vikram Samvat</span><span className="font-semibold text-gray-800">{panchangResult?.vikram_samvat} ({panchangResult?.vkram_samvat_name})</span></div>
                                                        <div><span className="text-gray-400 block">Shaka Samvat</span><span className="font-semibold text-gray-800">{panchangResult?.shaka_samvat} ({panchangResult?.shaka_samvat_name})</span></div>
                                                        <div><span className="text-gray-400 block">Disha Shool</span><span className="font-semibold text-gray-800">{panchangResult?.disha_shool || '-'}</span></div>
                                                        <div><span className="text-gray-400 block">Panchang Yog</span><span className="font-semibold text-gray-800">{panchangResult?.panchang_yog || '-'}</span></div>
                                                    </div>

                                                    {/* Auspicious & Inauspicious Timings */}
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 text-xs">
                                                        <div className="p-3 bg-emerald-50 border border-emerald-100 rounded-lg">
                                                            <span className="font-bold text-emerald-800 block">Abhijit Muhurta</span>
                                                            <span className="text-emerald-700">{panchangResult?.abhijit_muhurta?.start} - {panchangResult?.abhijit_muhurta?.end}</span>
                                                        </div>
                                                        <div className="p-3 bg-rose-50 border border-rose-100 rounded-lg">
                                                            <span className="font-bold text-rose-800 block">Rahu Kaal</span>
                                                            <span className="text-rose-700">{panchangResult?.rahukaal?.start} - {panchangResult?.rahukaal?.end}</span>
                                                        </div>
                                                        <div className="p-3 bg-amber-50 border border-amber-100 rounded-lg">
                                                            <span className="font-bold text-amber-800 block">Guli Kaal</span>
                                                            <span className="text-amber-700">{panchangResult?.guliKaal?.start} - {panchangResult?.guliKaal?.end}</span>
                                                        </div>
                                                        <div className="p-3 bg-purple-50 border border-purple-100 rounded-lg">
                                                            <span className="font-bold text-purple-800 block">Yamghant Kaal</span>
                                                            <span className="text-purple-700">{panchangResult?.yamghant_kaal?.start} - {panchangResult?.yamghant_kaal?.end}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                        </div>
                                    </section>
                                    <Kundli_Common_Section />
                                </>
                            )
                        }
                        {
                            astrology_data?.page_name === "free-kundli" && (
                                <>
                                    {/* <!--  Free Kundli section --> */}
                                    <section className="gi-category py-10 md:py-16 bg-[#F0F4F8]">
                                        <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100 flex flex-col md:flex-row gap-6 items-center mb-8">
                                                <div className="w-32 h-32 md:w-40 md:h-40 rounded-xl overflow-hidden shrink-0 border border-gray-100 shadow-sm">
                                                    <img
                                                        src={`${IMG_BASE_URL}${astrology_data?.image}`}
                                                        className="w-full h-full object-cover"
                                                        alt={astrology_data?.alt}
                                                    />
                                                </div>
                                                <div className="flex-grow text-center md:text-left">
                                                    <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{astrology_data?.title}</h1>
                                                    <div className="text-gray-600 text-sm md:text-base leading-relaxed sub__title">
                                                        {astrology_data?.short_description ? parse(String(astrology_data.short_description)) : ""}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <---------- Free Get janam Kundli form -----------> */}
                                            <div className="w-full">
                                                <Free_Get_Kundli_Form />
                                            </div>

                                            {/* Description Card */}
                                            {astrology_data?.description && (
                                                <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100 mt-8">
                                                    <div className="custome_viewbox prose max-w-none text-gray-700 leading-relaxed text-sm md:text-base">
                                                        {parse(String(astrology_data.description))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </section>
                                    <Kundli_Common_Section />
                                </>
                            )}

                        {
                            astrology_data?.page_name === "kundli-matching" && (
                                <>
                                    {/* <!--  Free Kundli section --> */}
                                    <section className="gi-category py-10 md:py-16 bg-[#F0F4F8]">
                                        <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100 flex flex-col md:flex-row gap-6 items-center mb-8">
                                                <div className="w-32 h-32 md:w-40 md:h-40 rounded-xl overflow-hidden shrink-0 border border-gray-100 shadow-sm">
                                                    <img
                                                        src={`${IMG_BASE_URL}${astrology_data?.image}`}
                                                        className="w-full h-full object-cover"
                                                        alt={astrology_data?.alt}
                                                    />
                                                </div>
                                                <div className="flex-grow text-center md:text-left">
                                                    <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{astrology_data?.title}</h1>
                                                    <div className="text-gray-600 text-sm md:text-base leading-relaxed sub__title">
                                                        {astrology_data?.short_description ? parse(String(astrology_data?.short_description)) : ""}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="w-full mt-6">
                                                <form onSubmit={handle_Submit} className="space-y-8">
                                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                                                        {/* Boy's Details Card */}
                                                        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
                                                            <div className="bg-gradient-to-r from-[#9F2225]/5 to-[#723F25]/5 px-6 py-4 border-b border-gray-100 flex items-center gap-3">
                                                                <img src={Common_Images_Transport?.boys_icon} className="w-6 h-6 object-contain" alt="" />
                                                                <h2 className="text-lg font-bold text-gray-900">Enter Boy's Details</h2>
                                                            </div>
                                                            <div className="p-6 space-y-4">
                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Name*</label>
                                                                    <input
                                                                        name="name"
                                                                        placeholder="Enter Name"
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        type="text"
                                                                        value={boys_Detail?.name}
                                                                        onChange={handle_BoyDetail}
                                                                        required
                                                                    />
                                                                </div>
                                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                                    <div>
                                                                        <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Birth Date & Time*</label>
                                                                        <input
                                                                            name="date_time"
                                                                            className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                            type="datetime-local"
                                                                            value={boys_Detail?.date_time}
                                                                            max={new Date().toISOString().slice(0, 16)}
                                                                            onChange={handle_BoyDetail}
                                                                            required
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Birth Place*</label>
                                                                        <input
                                                                            name="birth_place"
                                                                            placeholder="Enter Birth Place"
                                                                            className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                            type="text"
                                                                            value={boys_Detail?.birth_place}
                                                                            onChange={handle_BoyDetail}
                                                                            required
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Girl's Details Card */}
                                                        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
                                                            <div className="bg-gradient-to-r from-[#9F2225]/5 to-[#723F25]/5 px-6 py-4 border-b border-gray-100 flex items-center gap-3">
                                                                <img src={Common_Images_Transport?.girl_icon} className="w-6 h-6 object-contain" alt="" />
                                                                <h2 className="text-lg font-bold text-gray-900">Enter Girl's Details</h2>
                                                            </div>
                                                            <div className="p-6 space-y-4">
                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Name*</label>
                                                                    <input
                                                                        name="name"
                                                                        placeholder="Enter Name"
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        type="text"
                                                                        value={girl_Detail?.name}
                                                                        onChange={handle_GirlDetail}
                                                                        required
                                                                    />
                                                                </div>
                                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                                    <div>
                                                                        <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Birth Date & Time*</label>
                                                                        <input
                                                                            name="date_time"
                                                                            className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                            type="datetime-local"
                                                                            value={girl_Detail?.date_time}
                                                                            max={new Date().toISOString().slice(0, 16)}
                                                                            onChange={handle_GirlDetail}
                                                                            required
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Birth Place*</label>
                                                                        <input
                                                                            name="birth_place"
                                                                            placeholder="Enter Birth Place"
                                                                            className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                            type="text"
                                                                            value={girl_Detail?.birth_place}
                                                                            onChange={handle_GirlDetail}
                                                                            required
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Submit Grid */}
                                                    <div className="flex justify-center pt-4">
                                                        <button
                                                             type="submit"
                                                             disabled={is_match_submitting}
                                                             className="w-full md:w-[320px] h-12 bg-[#9F2225] hover:bg-[#831c1e] text-white text-sm font-bold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 uppercase tracking-wider disabled:opacity-60"
                                                         >
                                                             {is_match_submitting ? 'Generating...' : 'Match Kundli'}
                                                         </button>
                                                    </div>
                                                </form>
                                            </div>

                                            {/* Detailed JSON Report View */}
                                            {matchReportData && (
                                                <div className="mt-8 bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100 space-y-6">
                                                    {/* Header & Conclusion */}
                                                    <div className="border-b border-gray-100 pb-4">
                                                        <h2 className="text-xl font-bold text-gray-900 mb-1">Match Making Analysis</h2>
                                                        {matchReportData.conclusion?.match_report && (
                                                            <p className="text-sm text-amber-900 bg-amber-50 border border-amber-200 p-4 rounded-xl mt-3 leading-relaxed">
                                                                <strong className="block mb-1 text-amber-950 font-bold uppercase text-xs tracking-wider">Overall Match Recommendation:</strong>
                                                                {matchReportData.conclusion.match_report}
                                                            </p>
                                                        )}
                                                    </div>

                                                    {/* Summary Badges Grid */}
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 text-xs font-semibold">
                                                        {matchReportData.ashtakoota?.total && (
                                                            <div className="bg-[#9F2225]/5 border border-[#9F2225]/15 p-4 rounded-xl">
                                                                <span className="text-[#9F2225] font-bold block text-xs uppercase tracking-wider mb-1">Ashtakoota Score</span>
                                                                <span className="text-2xl font-extrabold text-gray-900">
                                                                    {matchReportData.ashtakoota.total.received_points} / {matchReportData.ashtakoota.total.total_points}
                                                                </span>
                                                                <span className="text-gray-500 block text-xs mt-1">Min Required: {matchReportData.ashtakoota.total.minimum_required}</span>
                                                            </div>
                                                        )}
                                                        {matchReportData.manglik && (
                                                            <div className="bg-purple-50 border border-purple-100 p-4 rounded-xl">
                                                                <span className="text-purple-900 font-bold block text-xs uppercase tracking-wider mb-1">Manglik Status</span>
                                                                <span className="text-sm text-purple-800 font-bold">
                                                                    {matchReportData.manglik.status ? "Manglik Present" : "No Manglik"}
                                                                </span>
                                                                <div className="text-xs text-purple-700 mt-1 font-normal">
                                                                    Boy: {matchReportData.manglik.male_percentage}% | Girl: {matchReportData.manglik.female_percentage}%
                                                                </div>
                                                            </div>
                                                        )}
                                                        {matchReportData.rajju_dosha && (
                                                            <div className="bg-rose-50 border border-rose-100 p-4 rounded-xl">
                                                                <span className="text-rose-900 font-bold block text-xs uppercase tracking-wider mb-1">Rajju Dosha</span>
                                                                <span className={`text-sm font-bold ${matchReportData.rajju_dosha.status ? "text-rose-600" : "text-emerald-600"}`}>
                                                                    {matchReportData.rajju_dosha.status ? "Dosha Present" : "No Dosha"}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {matchReportData.vedha_dosha && (
                                                            <div className="bg-emerald-50 border border-emerald-100 p-4 rounded-xl">
                                                                <span className="text-emerald-900 font-bold block text-xs uppercase tracking-wider mb-1">Vedha Dosha</span>
                                                                <span className={`text-sm font-bold ${matchReportData.vedha_dosha.status ? "text-rose-600" : "text-emerald-600"}`}>
                                                                    {matchReportData.vedha_dosha.status ? "Dosha Present" : "No Dosha"}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Ashtakoota Breakdown Table */}
                                                    {matchReportData.ashtakoota && (
                                                        <div>
                                                            <h3 className="text-base font-bold text-gray-900 mb-3">Ashtakoota Guna Details</h3>
                                                            <div className="overflow-x-auto border border-gray-100 rounded-xl">
                                                                <table className="w-full text-left text-xs">
                                                                    <thead className="bg-gray-50 border-b border-gray-100 text-gray-700 font-bold uppercase">
                                                                        <tr>
                                                                            <th className="p-3">Guna</th>
                                                                            <th className="p-3">Description</th>
                                                                            <th className="p-3">Boy Attribute</th>
                                                                            <th className="p-3">Girl Attribute</th>
                                                                            <th className="p-3 text-right">Points Obtained</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="divide-y divide-gray-100 text-gray-700">
                                                                        {['varna', 'vashya', 'tara', 'yoni', 'maitri', 'gan', 'bhakut', 'nadi'].map((kootKey) => {
                                                                            const koot = matchReportData.ashtakoota[kootKey];
                                                                            if (!koot) return null;
                                                                            return (
                                                                                <tr key={kootKey} className="hover:bg-gray-50/50">
                                                                                    <td className="p-3 font-bold capitalize text-gray-900">{kootKey}</td>
                                                                                    <td className="p-3 text-gray-600">{koot.description || '-'}</td>
                                                                                    <td className="p-3">{koot.male_koot_attribute || '-'}</td>
                                                                                    <td className="p-3">{koot.female_koot_attribute || '-'}</td>
                                                                                    <td className="p-3 text-right font-bold text-[#9F2225]">
                                                                                        {koot.received_points} / {koot.total_points}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            {matchReportData.ashtakoota?.conclusion?.report && (
                                                                <p className="text-xs text-gray-600 mt-3 italic bg-gray-50 p-3 rounded-lg border border-gray-100">
                                                                    {matchReportData.ashtakoota.conclusion.report}
                                                                </p>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* PDF Report Alert */}
                                            {matchPdfUrl && (
                                                <div className="mt-8 p-6 bg-green-50 border border-green-200 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-4">
                                                    <div>
                                                        <p className="text-green-800 font-bold text-lg">Kundli Matching Report is ready!</p>
                                                        <p className="text-green-700 text-sm mt-0.5">You can download and review the detailed comparison PDF.</p>
                                                    </div>
                                                    <a
                                                        href={matchPdfUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="inline-flex items-center gap-2 px-6 py-3 bg-[#9F2225] hover:bg-red-800 text-white text-sm font-bold rounded-lg shadow-md transition-all duration-200 uppercase tracking-wide shrink-0"
                                                    >
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                                                        </svg>
                                                        Download PDF Report
                                                    </a>
                                                </div>
                                            )}

                                            {/* Description Card */}
                                            {astrology_data?.description && (
                                                <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100 mt-8">
                                                    <div className="custome_viewbox prose max-w-none text-gray-700 leading-relaxed text-sm md:text-base">
                                                        {parse(String(astrology_data?.description))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </section>
                                    <Kundli_Common_Section />
                                </>
                            )}

                        {
                            astrology_data?.page_name === "kaalsarp-doshas" && (
                                <section className="gi-faq py-12 bg-[#F0F4F8]">
                                    <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-md border border-gray-100">
                                            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{astrology_data?.title}</h1>
                                            <div className="h-[2px] w-16 bg-[#9F2225] mb-6"></div>
                                            <div className="custome_viewbox prose max-w-none text-gray-700 leading-relaxed text-sm md:text-base">
                                                {astrology_data?.description ? parse(String(astrology_data.description)) : ""}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "nakshatras-constellations" && (
                                <section className="gi-faq py-12 bg-[#F0F4F8]">
                                    <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-md border border-gray-100">
                                            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{astrology_data?.title}</h1>
                                            <div className="h-[2px] w-16 bg-[#9F2225] mb-6"></div>
                                            <div className="custome_viewbox prose max-w-none text-gray-700 leading-relaxed text-sm md:text-base">
                                                {astrology_data?.description ? parse(String(astrology_data.description)) : ""}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "numerology" && (
                                <section className="gi-faq py-12 bg-[#F0F4F8]">
                                    <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-md border border-gray-100">
                                            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{astrology_data?.title}</h1>
                                            <div className="h-[2px] w-16 bg-[#9F2225] mb-6"></div>
                                            <div className="custome_viewbox prose max-w-none text-gray-700 leading-relaxed text-sm md:text-base">
                                                {astrology_data?.description ? parse(String(astrology_data.description)) : ""}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "astrology-yoga" && (
                                <section className="gi-faq py-12 bg-[#F0F4F8]">
                                    <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-md border border-gray-100">
                                            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{astrology_data?.title}</h1>
                                            <div className="h-[2px] w-16 bg-[#9F2225] mb-6"></div>
                                            <div className="custome_viewbox prose max-w-none text-gray-700 leading-relaxed text-sm md:text-base">
                                                {astrology_data?.description ? parse(String(astrology_data.description)) : ""}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "child-astrology" && (
                                <section className="gi-faq py-12 bg-[#F0F4F8]">
                                    <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-md border border-gray-100">
                                            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{astrology_data?.title}</h1>
                                            <div className="h-[2px] w-16 bg-[#9F2225] mb-6"></div>
                                            <div className="custome_viewbox prose max-w-none text-gray-700 leading-relaxed text-sm md:text-base">
                                                {astrology_data?.description ? parse(String(astrology_data.description)) : ""}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            )}
                        {
                            astrology_data?.page_name === "love-calculator" && (
                                <>
                                    <section className="gi-category py-10 md:py-16 bg-[#F0F4F8]">
                                        <div className="px-5 mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                            {/* Header Card */}
                                            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100 flex flex-col md:flex-row gap-6 items-center mb-8">
                                                <div className="w-32 h-32 md:w-40 md:h-40 rounded-xl overflow-hidden shrink-0 border border-gray-100 shadow-sm">
                                                    <img
                                                        src={`${IMG_BASE_URL}${astrology_data?.image}`}
                                                        className="w-full h-full object-cover"
                                                        alt={astrology_data?.alt}
                                                    />
                                                </div>
                                                <div className="flex-grow text-center md:text-left">
                                                    <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{astrology_data?.title}</h1>
                                                    <div className="text-gray-600 text-sm md:text-base leading-relaxed sub__title">
                                                        {astrology_data?.short_description ? parse(String(astrology_data.short_description)) : ""}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Form Container */}
                                            <div className="w-full mt-6">
                                                {errorMessage && (
                                                    <div className="mb-6 p-4 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">
                                                        {errorMessage}
                                                    </div>
                                                )}

                                                <form onSubmit={HandleSubmitLoveCalculator} className="space-y-6">
                                                    <div className="grid grid-cols-1 lg:grid-cols-11 gap-3 items-center">
                                                        {/* Your Details Card */}
                                                        <div className="lg:col-span-5 bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
                                                            <div className="bg-gradient-to-r from-[#9F2225]/5 to-[#723F25]/5 px-6 py-4 border-b border-gray-100 flex items-center gap-3">
                                                                <span className="text-xl">👤</span>
                                                                <h2 className="text-lg font-bold text-gray-900">Your Details</h2>
                                                            </div>
                                                            <div className="p-6 space-y-4">
                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Your Name*</label>
                                                                    <input
                                                                        placeholder="Enter Name"
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        type="text"
                                                                        value={love_calculator_form.name}
                                                                        name="name"
                                                                        onChange={HandleLoveCalclatorChange}
                                                                        required
                                                                    />
                                                                </div>

                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Your Gender*</label>
                                                                    <div className="flex gap-6 mt-2">
                                                                        <label className="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                                                            <input
                                                                                type="radio"
                                                                                value="male"
                                                                                name="your_gender"
                                                                                onChange={HandleLoveCalclatorChange}
                                                                                checked={love_calculator_form.your_gender === "male"}
                                                                                className="w-4 h-4 text-[#9F2225] focus:ring-[#9F2225] border-gray-300"
                                                                                required
                                                                            />
                                                                            Male
                                                                        </label>
                                                                        <label className="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                                                            <input
                                                                                type="radio"
                                                                                value="female"
                                                                                name="your_gender"
                                                                                onChange={HandleLoveCalclatorChange}
                                                                                checked={love_calculator_form.your_gender === "female"}
                                                                                className="w-4 h-4 text-[#9F2225] focus:ring-[#9F2225] border-gray-300"
                                                                            />
                                                                            Female
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Birth Date & Time*</label>
                                                                    <input
                                                                        name="your_dob"
                                                                        type="datetime-local"
                                                                        max={new Date().toISOString().slice(0, 16)}
                                                                        value={love_calculator_form.your_dob}
                                                                        onChange={HandleLoveCalclatorChange}
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        required
                                                                    />
                                                                </div>

                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Birth Place*</label>
                                                                    <input
                                                                        name="your_birth_place"
                                                                        type="text"
                                                                        placeholder="Enter birth place"
                                                                        value={love_calculator_form.your_birth_place}
                                                                        onChange={HandleLoveCalclatorChange}
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Heart Image / Divider */}
                                                        <div className="lg:col-span-1 flex justify-center items-center py-4 lg:py-0">
                                                            <div className="bg-white p-3 rounded-full shadow-md border border-gray-100 hover:scale-110 transition-transform duration-300">
                                                                <img
                                                                    src={Common_Images_Transport?.love_calendar}
                                                                    className="w-12 h-12 lg:w-16 lg:h-16 object-contain"
                                                                    alt="Heart Divider"
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Partner's Details Card */}
                                                        <div className="lg:col-span-5 bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
                                                            <div className="bg-gradient-to-r from-[#9F2225]/5 to-[#723F25]/5 px-6 py-4 border-b border-gray-100 flex items-center gap-3">
                                                                <span className="text-xl">💖</span>
                                                                <h2 className="text-lg font-bold text-gray-900">Partner's Details</h2>
                                                            </div>
                                                            <div className="p-6 space-y-4">
                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Partner's Name*</label>
                                                                    <input
                                                                        placeholder="Enter Partner's Name"
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        type="text"
                                                                        value={love_calculator_form.partner_name}
                                                                        name="partner_name"
                                                                        onChange={HandleLoveCalclatorChange}
                                                                        required
                                                                    />
                                                                </div>

                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Partner's Gender*</label>
                                                                    <div className="flex gap-6 mt-2">
                                                                        <label className="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                                                            <input
                                                                                type="radio"
                                                                                value="male"
                                                                                name="partner_gender"
                                                                                onChange={HandleLoveCalclatorChange}
                                                                                checked={love_calculator_form.partner_gender === "male"}
                                                                                className="w-4 h-4 text-[#9F2225] focus:ring-[#9F2225] border-gray-300"
                                                                                required
                                                                            />
                                                                            Male
                                                                        </label>
                                                                        <label className="flex items-center gap-2 cursor-pointer text-sm text-gray-700">
                                                                            <input
                                                                                type="radio"
                                                                                value="female"
                                                                                name="partner_gender"
                                                                                onChange={HandleLoveCalclatorChange}
                                                                                checked={love_calculator_form.partner_gender === "female"}
                                                                                className="w-4 h-4 text-[#9F2225] focus:ring-[#9F2225] border-gray-300"
                                                                            />
                                                                            Female
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Birth Date & Time*</label>
                                                                    <input
                                                                        name="partner_dob"
                                                                        type="datetime-local"
                                                                        max={new Date().toISOString().slice(0, 16)}
                                                                        value={love_calculator_form.partner_dob}
                                                                        onChange={HandleLoveCalclatorChange}
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        required
                                                                    />
                                                                </div>

                                                                <div>
                                                                    <label className="text-xs font-semibold text-gray-700 mb-1.5 block">Birth Place*</label>
                                                                    <input
                                                                        name="partner_birth_place"
                                                                        type="text"
                                                                        placeholder="Enter birth place"
                                                                        value={love_calculator_form.partner_birth_place}
                                                                        onChange={HandleLoveCalclatorChange}
                                                                        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-700 bg-gray-50 focus:bg-white focus:border-[#9F2225] focus:ring-2 focus:ring-[#9F2225]/15 transition-all duration-200 outline-none h-11"
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="flex justify-center pt-3">
                                                        <button
                                                            type="submit"
                                                            disabled={is_love_submitting}
                                                            className="w-full md:w-[320px] h-12 bg-[#9F2225] hover:bg-[#831c1e] text-white text-sm font-bold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 uppercase tracking-wider disabled:opacity-60"
                                                        >
                                                            {is_love_submitting ? 'Calculating...' : 'Calculate Love Compatibility'}
                                                        </button>
                                                    </div>
                                                </form>

                                                {/* Compatibility Report Card */}
                                                {loveReport.length > 0 && (
                                                    <div className="w-full mt-8 bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100">
                                                        <h2 className="text-xl font-bold text-[#9F2225] mb-6 border-b border-gray-100 pb-3 flex items-center gap-2">
                                                            <span>❤️</span> Love Compatibility Report
                                                        </h2>
                                                        <div className="space-y-4">
                                                            {loveReport.map((para, idx) => (
                                                                <p key={idx} className="text-gray-700 text-sm md:text-base leading-relaxed border-l-4 border-[#9F2225] pl-4 py-1.5">
                                                                    {para}
                                                                </p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Description Card */}
                                                {astrology_data?.description && (
                                                    <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100 mt-8">
                                                        <div className="custome_viewbox prose max-w-none text-gray-700 leading-relaxed text-sm md:text-base">
                                                            {parse(String(astrology_data.description))}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Horoscopes Card */}
                                                <div className="w-full mt-6 bg-white p-6 md:p-8 rounded-2xl shadow-md border border-gray-100">
                                                    <h2 className="border-b border-gray-100 pb-4 font-bold text-[#9F2225] text-xl mb-6">
                                                        Horoscopes
                                                    </h2>
                                                    <div className="w-full grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
                                                        <Horoscope />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <Kundli_Common_Section />
                                </>
                            )}
                        <Home_Private_Confidential />
                        <Footer />
                    </>
                )}
        </div>
    );
}